$(window).on('load', function() {
	$('link[rel=stylesheet][href~="screen.min.css"]').remove();
});

function replacePreload(el) {
    setTimeout(function(){ el.attr('rel', 'stylesheet').removeClass('preloaded') }, 500)
}

function runInlineScript() {
    //Inline Javascript for Hero Form Js
    $('.preloaded').each(function() {
        replacePreload($(this))
    });
};

document.addEventListener("DOMContentLoaded", function(event) {
    runInlineScript();
});
// automate readtime for articles
var txt = $(".articleWrapper-content--left")[0].textContent,
wordCount = txt.replace( /[^\w ]/g, "" ).split( /\s+/ ).length;

var readingTimeInMinutes = Math.floor(wordCount / 228) + 1;
var readingTimeAsString = readingTimeInMinutes + " min read";
$("#articleAuthor-info--reading").html(readingTimeAsString);

jQuery(function($){

	const SIDEBAR_SLIDER_CONFIG = {
		dots: true,
		infinite: true,
		speed: 300,
		arrows: false,
		slidesToShow: 1,
		autoplay: true,
		autoplaySpeed: 4000,
		pauseOnHover: true
	}

	$('.new-article-mobile-slider-block').slick({
		dots: true,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 4000,
	});

	let countId = 0;
	function triggerSidebarSlider(el) {

		if(el.find('img').hasClass('loaded')) {
			var $slideshow =  el.slick(SIDEBAR_SLIDER_CONFIG);

			$('.sidebar .new-article-sidebar h3').click(function() {
				$slideshow.slick('slickNext');
			});
		} else {
			countId++;
			if (countId < 5) {
				setTimeout(()=> { triggerSidebarSlider(el) }, 1000) 
			} else {
				// force add loaded class after 5s
				$('.new-article-sidebar--slider img').addClass("loaded").removeClass("loading");
				triggerSidebarSlider(el);
			}
			
		}
		
	}

	triggerSidebarSlider( $('.new-article-sidebar--slider') );

	if( $('.money-life-cover').length > 0 ) 
		$( '.sidebar' ).clone().prependTo('.money-life-cover');
});



jQuery(function($){
	var viewportWidth = $(window).width();
	if (viewportWidth > 768 ) {
		var brandSlider = $('.brand-slider-flexi');

		if(brandSlider.length > 0 && !brandSlider.hasClass('slick-initialized'))
		brandSlider.slick({
			dots: false,
			infinite: true,
			speed: 300,
			slidesToShow: 9,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 3000
		});
		var $sidebar   = $(".articleWrapper-content--right .sticky-sidebar"),
			$window    = $(window),
			offset     = $sidebar.offset(),
			topPadding = 5;
		var $sidebarheight = $sidebar.height() - 100;
			$sidebar.css({position:'relative', top: 0});

		if($sidebar){
			$window.scroll(function() {
				if ($window.scrollTop() > offset.top && $(window).scrollTop() < (($('.articleWrapper').height()-$sidebarheight)-$window.height())) {
					$sidebar.stop().css({
						top: $window.scrollTop() - offset.top + topPadding
					});
				} else {
					$sidebar.stop().css({
						top: 0
					});
				}
			});
		}
	}
});



